import { Home } from 'lucide-react';
import ChatCard from '../ChatCard';
import { Button } from '@/shared/ui/button.tsx';
import ThemeCalendar from "./ThemeCalendar"
import { useGetCalendarEvents, useGetCalendarFreq, useGetPostTimeline } from '../../api';
import { endOfMonth, startOfMonth } from 'date-fns';
import Timeline from './Timeline';
import { ChatMessageType } from '../../types';
import { Separator } from '@/shared/ui/separator.tsx';

type Props = {
  setStep: (id: ChatMessageType) => void
}

const SocialCalendar = ({ setStep }: Props) => {

  const { calendarEvents } = useGetCalendarEvents(startOfMonth(new Date()), endOfMonth(new Date()))
  const { calendarFreq } = useGetCalendarFreq()

  const { timeline } = useGetPostTimeline()

  return (
    <>
      <ChatCard user="client">
        <p className="w-full text-end font-poppins text-sm text-gray-500">I want an overview of my social media activity</p>
      </ChatCard>
      <ChatCard user="assistant">
        <div className="w-full flex flex-col gap-8 h-full">
          <div className="w-full flex flex-col gap-3 ">
            <div className='flex flex-col lg:flex-row items-center gap-4 h-full flex-1 min-h-64'>
              {calendarEvents && calendarFreq &&
                <ThemeCalendar events={calendarEvents.data} frequencies={calendarFreq} />
              }
              <Separator className='w-[2px] h-[20rem] bg-purple-300 hidden lg:block' orientation='vertical' />
              <Separator className='w-full h-[2px] bg-purple-300 block lg:hidden' orientation='horizontal' />
              <div className='w-full lg:w-1/2 flex flex-col gap-2 h-[20rem] overflow-auto'>
                {timeline && <Timeline timeline={timeline.timeline} />}
              </div>
            </div>
            <div className="w-full flex items-center justify-end">
              <Button
                onClick={() => setStep("navigation")}
                variant="outline"
                size="icon"
                className="rounded-full font-poppins border-2 border-purple-400 hover:bg-white tracking-wide text-purple-600"
              >
                <Home />
              </Button>
            </div>
          </div>
        </div>
      </ChatCard>
    </>
  )
}

export default SocialCalendar;
